//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/SelectTaggedObject.js";
import "../Drawings/Drawings.SelectDraftingView.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"AlignmentMethod",1,0],[0,"AlignmentOption",1,0],[1,"AlignmentPoint",0,"SelectTaggedObject",0],[0,"AlignmentVector",1,"Direction",0],[1,"AlignmentView",0,"Drawings.SelectDraftingView",0],[0,"Associative",1,0],[1,"CandidatePoint",0,"SelectTaggedObject",0],[0,"LockOffset",1,0],[0,"Offset",1,0],[1,"Placement",0,"SelectNXObject",0]],[[["parentView"],"GetPointForViewAlignment",{R_:{anchorPoint:"Point"}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.ViewPlacementBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewPlacementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewPlacementBuilder.Method = Object.freeze({
    "Infer" : "Infer", "Horizontal" : "Horizontal", "Vertical" : "Vertical", "PerpendicularToLine" : "PerpendicularToLine", "Overlay" : "Overlay", "PerpendicularToHingeLine" : "PerpendicularToHingeLine", "Max" : "Max"});

SPLM.Drawings.ViewPlacementBuilder.Option = Object.freeze({
    "ToView" : "ToView", "ModelPoint" : "ModelPoint", "PointToPoint" : "PointToPoint"});

export default SPLM;